import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

const PrivateRoute = ({ component: Component, auth, ...rest }) =>
	<Route {...rest} render={props => (
		auth.isAuthenticated ? (
			<Component {...props} />
		) : (
				<Redirect to={{
					pathname: '/public/centers',
					search: props.location.search,
					state: { from: props.location }
				}}
				/>
			)
	)}
	/>;

const mapStateToProps = (state, ownProps) => ({
	auth: state.auth
});

export default connect(mapStateToProps)(PrivateRoute);